import { FormikConfig, FormikValues } from "formik/dist/types";
import { useFormik } from "formik";
import { useState } from "react";

interface FormConfig<Values> extends FormikConfig<Values> {
}

export default function useForm<Values extends FormikValues = FormikValues>(config: FormConfig<Values>) {
  const formik = useFormik(config);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  
  function updateFieldValue<T extends keyof Values>(fieldName: T, value: Values[T], shouldValidate?: boolean) {
    formik.setFieldValue(fieldName as string, value, shouldValidate);
  }
  
  const getFormErrorMessage = (field: keyof Values) => {
    const valueError = formik.errors[field];
    const isFormFieldInvalid = valueError !== undefined && isFormSubmitted;
    return isFormFieldInvalid ? String(valueError) : undefined;
  };

  
  const checkErrorAndSubmit = async (showClientError?: (errorText: string) => void) => {
    const formErrors = await formik.validateForm(formik.values);
    setIsFormSubmitted(true);
    const keys = Object.keys(formErrors);
    if (keys.length > 0) {
      for (const key of keys) {
        if (formErrors[key]) {
          if(typeof formErrors[key] === "object") {
            showClientError?.(`Vui lòng nhập đầy đủ thông tin`);
          } else {
            showClientError?.(`${String(formErrors[key])}`);
          }
   
          return;
        }
      }
    } else {
      await formik.submitForm();
    }
  };
  
  const {
    setFieldValue,
    ...restFormik
  } = formik;
  
  return {
    ...restFormik,
    updateFieldValue,
    getFormErrorMessage,
    checkErrorAndSubmit
  };
}
